import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Rodeo } from '../../../../model/rodeo';
import { RodeoEvent } from '../../../../model/rodeoEvent';
import { RodeoEventSchedule } from '../../../../model/rodeoEventSchedule';

@Component({
	selector: 'page-no-preference-list-report',
	templateUrl: 'report-no-preference-list.html'
	
})
export class NoPreferenceListReport {
    @Input('rodeo') rodeo: Rodeo;
    @Output('loading') loading = new EventEmitter<boolean>(false);
    cleanedSchedules: RodeoEventSchedule[][] = [];

    ionViewWillEnter() {
        this.loading.emit(true);
        this.cleanedSchedules = [];

        this.rodeo.rodeoEvents.forEach(o => {
            this.cleanedSchedules[o.id] = [];

            o.schedules.forEach(x => {
                var newSchedule = new RodeoEventSchedule();
                newSchedule.name = x.name;
                newSchedule.runs = [];
                this.cleanedSchedules[o.id][x.id] = newSchedule;

                x.runs.forEach(y => {
                    var registrations = o.registrations.filter(z => z.contestantOneId == y.contestantOneId || (z.teammateHeader && z.contestantTwoId == y.contestantOneId));

                    if (registrations.length > 0) {
                        var registration = registrations[0];

                        if (!registration.allPreferences && !registration.scheduleIds.some(a => a == x.id)) {
                            this.cleanedSchedules[o.id][x.id].runs.push(y);
                        }
                    }
                });
            });
        });

        this.loading.emit(false);
    }

    getNoPreferenceRuns(rodeoEvent: RodeoEvent) {
        return this.cleanedSchedules[rodeoEvent.id];
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/reports/report-no-preference-list.ts